import { createFileRoute } from "@tanstack/react-router";
import DonateLayout from "@project/donate/pages/layout";

export const Route = createFileRoute("/donate")({
  component: DonateLayout,
});
